import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PhoneField } from "@/components/common/PhoneField";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function PortalProfile() {
  const { logout } = useAuth();
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/portal/home").then((r) => setC(r.data.client)); }, []);
  const save = async () => {
    try { await api.put("/portal/profile", { first_name: c.first_name, last_name: c.last_name, phone: c.phone, marketing_consent: c.marketing_consent, channel_prefs: c.channel_prefs }); toast.success("Profilo aggiornato"); }
    catch { toast.error("Errore"); }
  };
  if (!c) return <div className="h-64 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--hi-gold))]" /></div>;
  return (
    <div className="space-y-5">
      <h1 className="font-heading text-2xl font-semibold">Il mio profilo</h1>
      <Card className="p-5 space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label>Nome</Label><Input value={c.first_name || ""} onChange={(e) => setC({ ...c, first_name: e.target.value })} data-testid="profile-first-name" /></div>
          <div className="space-y-1.5"><Label>Cognome</Label><Input value={c.last_name || ""} onChange={(e) => setC({ ...c, last_name: e.target.value })} /></div>
        </div>
        <div className="space-y-1.5"><Label>Email</Label><Input value={c.email || ""} disabled /></div>
        <div className="space-y-1.5"><Label>Telefono</Label><PhoneField value={c.phone || ""} onChange={(v) => setC({ ...c, phone: v })} testid="profile-phone" /></div>
        <div className="flex items-center justify-between border-t border-border pt-4"><div><Label>Comunicazioni marketing</Label><p className="text-xs text-muted-foreground">Offerte e novità dal salone</p></div><Switch checked={!!c.marketing_consent} onCheckedChange={(v) => setC({ ...c, marketing_consent: v })} data-testid="profile-marketing" /></div>
        <div className="border-t border-border pt-4 space-y-3">
          <Label>Preferenze canali (promemoria)</Label>
          {[["email_operational", "Email"], ["whatsapp_operational", "WhatsApp"], ["push", "Notifiche push"]].map(([k, lbl]) => (
            <div key={k} className="flex items-center justify-between"><span className="text-sm text-muted-foreground">{lbl}</span>
              <Switch checked={!!(c.channel_prefs || {})[k]} onCheckedChange={(v) => setC({ ...c, channel_prefs: { ...(c.channel_prefs || {}), [k]: v } })} data-testid={`profile-channel-${k}`} /></div>
          ))}
        </div>
        <Button className="w-full" onClick={save} data-testid="profile-save">Salva modifiche</Button>
      </Card>
      <Button variant="outline" className="w-full" onClick={logout}>Esci</Button>
    </div>
  );
}
